<template>
<div>
  <nav>
    <ul class="main">
      <li>
        <ul>
          <div class="home"></div>
        </ul>
      </li>
      <li>
        <a @click="controlProduct">IOT产品</a>
        <!--<ul class="drop menu1">
          <li><a @click="controlProduct" style="font-size: 1vh">边缘控制器</a></li>
          <li><a style="font-size: 1vh" href="#">控制模块</a></li>
          <li><a style="font-size: 1vh" href="#">传感器</a></li>
          <li><a style="font-size: 1vh" href="#">NFC读卡器</a></li>
          <li><a style="font-size: 1vh" href="#">触摸屏</a></li>
          <li><a style="font-size: 1vh" href="#">物联网盘柜</a></li>
        </ul>-->
      </li>
      <li><a href="#">场景/案例</a>
       <!-- <ul class="drop menu2">
          <li><a style="font-size: 1vh" href="#">微领实验室会议室</a></li>
          <li><a style="font-size: 1vh" href="#">苏州厂房</a></li>
          <li><a style="font-size: 1vh" href="#">实验室冷冻站</a></li>
          <li><a style="font-size: 1vh" href="#">实验室空调机房</a></li>
          <li><a style="font-size: 1vh" href="#">太湖别墅</a></li>
          <li><a style="font-size: 1vh" href="#">中基办公空间</a></li>
          <li><a style="font-size: 1vh" href="#">上海国贸</a></li>
          <li><a style="font-size: 1vh" href="#">兰生大厦</a></li>
          <li><a style="font-size: 1vh" href="#">桃浦项目</a></li>
          <li><a style="font-size: 1vh" href="#">中交展厅</a></li>
          <li><a style="font-size: 1vh" href="#">腾讯大厦34F</a></li>
        </ul>-->
      </li>
      <li><a href="#">应用/服务</a>
        <!--<ul class="drop menu3">
          <li><a style="font-size: 1vh" href="#">冷源群控</a></li>
          <li><a style="font-size: 1vh" href="#">空调新风机组</a></li>
          <li><a style="font-size: 1vh" href="#">建筑空间管理</a></li>
          <li><a style="font-size: 1vh" href="#">智慧配电</a></li>
          <li><a style="font-size: 1vh" href="#">智慧灯杆</a></li>
          <li><a style="font-size: 1vh" href="#">智慧交通</a></li>
          <li><a style="font-size: 1vh" href="#">电动机管理</a></li>
          <li><a style="font-size: 1vh" href="#">环境监测</a></li>
          <li><a style="font-size: 1vh" href="#">机器学习</a></li>
          <li><a style="font-size: 1vh" href="#">物业服务</a></li>
        </ul>-->
      </li>
      <li><a @click="aboutAim">关于我们</a>
      <!--  <ul class="drop menu4">
          <li><a style="font-size: 1vh" @click="aboutAim">AIM</a></li>
          <li><a style="font-size: 1vh" href="#">合作伙伴</a></li>
          <li><a style="font-size: 1vh" href="#">物联网控制系统</a></li>
        </ul>-->
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
export default {
  name: 'Demo',
  components: {

  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    controlProduct(){
      this.$router.push({name: 'Controls'})
    },
    aboutAim(){
      this.$router.push({name: 'About'})
    }
  }
}
</script>
<style scoped>
  ul {
    list-style: none;
  }

  nav {
    height: 40px;
    margin: 0px auto;
    background-color: transparent;
    text-align: center;
    border-radius: 4px;
  }
  .main {
    display: flex;
    justify-content: center;
  }
  .main > li {
    margin: 0 2%;
  }
  .main > li a{
    border-left:transparent;
  }
  a {
    text-decoration: none;
    color: #ffe;
    text-transform: capitalize;
    font-family: monospace;
    display: block;
    padding: 10px 15px;
    font-size: 1.7vh;
    transition: background-color 0.5s ease-in-out;
    font-family: "Raleway", sans-serif;
  }

  a:hover {
    background-color: rgba(108, 103, 102, 0.59);
    color: yellow;
  }

  .drop li {
    opacity: 0;
    transform-origin: top center;
  }

  .drop li a {
    background-color: rgba(108, 103, 102, 0.59);
    padding: 10px 0;
  }

  /*------------- menu1 animation -------------------*/

  .main li:hover .menu1 li:first-of-type {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 0.2s;
  }

  .main li:hover .menu1 li:nth-of-type(2) {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 0.4s;
  }

  .main li:hover .menu1 li:nth-of-type(3) {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }
  .main li:hover .menu1 li:nth-of-type(4) {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 0.8s;
  }
  .main li:hover .menu1 li:nth-of-type(5) {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 1.0s;
  }
  .main li:hover .menu1 li:last-of-type {
    animation: menu1 0.3s ease-in-out forwards;
    animation-delay: 1.2s;
  }

  @keyframes menu1 {
    from {
      opacity: 0;
      transform: translateX(30px) rotateY(90deg);
    }
    to {
      opacity: 1;
      transform: translateX(0) rotateY(0);
    }
  }

  /*------------- menu2 animation -------------------*/

  .main li:hover .menu2 li:first-of-type {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 0.2s;
  }

  .main li:hover .menu2 li:nth-of-type(2) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 0.4s;
  }

  .main li:hover .menu2 li:nth-of-type(3) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }
  .main li:hover .menu2 li:nth-of-type(4) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 0.8s;
  }
  .main li:hover .menu2 li:nth-of-type(5) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 1.0s;
  }
  .main li:hover .menu2 li:nth-of-type(6) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 1.2s;
  }
  .main li:hover .menu2 li:nth-of-type(7) {
     animation: menu2 0.3s ease-in-out forwards;
     animation-delay: 1.4s;
   }
  .main li:hover .menu2 li:nth-of-type(8) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 1.6s;
  }
  .main li:hover .menu2 li:nth-of-type(9) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 1.8s;
  }
  .main li:hover .menu2 li:nth-of-type(10) {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 2.0s;
  }
  .main li:hover .menu2 li:last-of-type {
    animation: menu2 0.3s ease-in-out forwards;
    animation-delay: 2.2s;
  }

  @keyframes menu2 {
    0% {
      opacity: 0;
      transform: scale(0.7);
    }
    50% {
      opacity: 0.5;
      transform: scale(1.1);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  /*------------- menu3 animation -------------------*/

  .main li:hover .menu3 li:first-of-type {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 0.2s;
  }

  .main li:hover .menu3 li:nth-of-type(2) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 0.4s;
  }

  .main li:hover .menu3 li:nth-of-type(3) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }
  .main li:hover .menu3 li:nth-of-type(4) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 0.8s;
  }
  .main li:hover .menu3 li:nth-of-type(5) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 1.0s;
  }
  .main li:hover .menu3 li:nth-of-type(6) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 1.2s;
  }
  .main li:hover .menu3 li:nth-of-type(7) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 1.4s;
  }
  .main li:hover .menu3 li:nth-of-type(8) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 1.6s;
  }
  .main li:hover .menu3 li:nth-of-type(9) {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 1.8s;
  }
  .main li:hover .menu3 li:last-of-type {
    animation: menu3 0.3s ease-in-out forwards;
    animation-delay: 2.0s;
  }

  @keyframes menu3 {
    0% {
      opacity: 0;
      transform: translateX(20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /*------------- menu4 animation -------------------*/

  .main li:hover .menu4 li:first-of-type {
    animation: menu4 0.3s ease-in-out forwards;
    animation-delay: 0.2s;
  }

  .main li:hover .menu4 li:nth-of-type(2) {
    animation: menu4 0.3s ease-in-out forwards;
    animation-delay: 0.4s;
  }


  .main li:hover .menu4 li:last-of-type {
    animation: menu4 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }

  @keyframes menu4 {
    0% {
      opacity: 0;
      transform: translateX(50px) rotate(-90deg);
    }
    100% {
      opacity: 1;
      transform: translateX(0) rotate(0);
    }
  }

  /*------------- menu5 animation -------------------*/

  .main li:hover .menu5 li:first-of-type {
    animation: menu5 0.3s ease-in-out forwards;
    animation-delay: 0.3s;
  }

  .main li:hover .menu5 li:nth-of-type(2) {
    animation: menu5 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }

  .main li:hover .menu5 li:nth-of-type(3) {
    animation: menu5 0.3s ease-in-out forwards;
    animation-delay: 0.9s;
  }

  .main li:hover .menu5 li:last-of-type {
    animation: menu5 0.3s ease-in-out forwards;
    animation-delay: 1.2s;
  }

  @keyframes menu5 {
    0% {
      opacity: 0;
      transform: rotateX(-90deg);
    }
    100% {
      opacity: 1;
      transform: rotateX(0);
    }
  }

  /*------------- menu6 animation -------------------*/

  .main li:hover .menu6 li:first-of-type {
    animation: menu6 0.3s ease-in-out forwards;
    animation-delay: 0.2s;
  }

  .main li:hover .menu6 li:nth-of-type(2) {
    animation: menu6 0.3s ease-in-out forwards;
    animation-delay: 0.4s;
  }

  .main li:hover .menu6 li:nth-of-type(3) {
    animation: menu6 0.3s ease-in-out forwards;
    animation-delay: 0.6s;
  }

  .main li:hover .menu6 li:last-of-type {
    animation: menu6 0.3s ease-in-out forwards;
    animation-delay: 0.8s;
  }

  @keyframes menu6 {
    0% {
      opacity: 0;
      transform: scale(2);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
.home{
  width: 25px;
  height: 20px;
  background-image: url('/static/img/homepage/home.png');
  background-size: 100% 100%;
  margin-top: 8px;
}
  /* my button style */
  .white-mode {
    text-decoration: none;
    padding: 7px 10px;
    background-color: #122;
    border-radius: 3px;
    color: #fff;
    transition: 0.35s ease-in-out;
    position: absolute;
    left: 15px;
    bottom: 15px;
    font-family: sans-serif;
  }

  .white-mode:hover {
    background-color: #fff;
    color: #122;
  }
</style>




// WEBPACK FOOTER //
// src/pages/homePageAssembly/nav.vue